/**
 * Created by Kieran on 06/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let NotificationsApi = {
  /**
   * @returns {AxiosPromise}
   */
  getNotifications(skip = 0) {
    const limit = 5;
    return axios.get(`${config.apiUrl}notifications/user/v2?limit=${limit}&skip=${skip}`)
  },
  markAsRead(model) {
    return axios.post(config.apiUrl + 'notifications/read/v2', model)
  },
  bulkReadNotifications(model) {
    return axios.post(config.apiUrl + 'notifications/read/bulk', model)
  }
};

export default NotificationsApi



// WEBPACK FOOTER //
// ./src/api/Notifications/index.js